import { usePlanContext } from "./planProvider/PlanProvider";
import { useUserContext } from "./userContextProvider/UserContextProvider";

export function usePermissionsProvider() {
    const { platformFeatures, addonsFeatures } = usePlanContext();
    const { permissions } = useUserContext();

    function hasAnnualWheelActivityAccess() {
        return platformFeatures.annualWheelOverview && permissions.annualWheelPermission.read;
    }

    function hasTaskManagementAccess() {
        return platformFeatures.annualWheelOverview && permissions.taskPermissions.read;
    }

    const hasTagsAccess = platformFeatures.tags && permissions.canAccessTags;

    const hasEnterpriseRiskManagementAccess = addonsFeatures.enterpriseRiskManagement && permissions.canAccessEnterpriseRiskManagement;

    return {
        hasAnnualWheelActivityAccess,
        hasTaskManagementAccess,
        hasTagsAccess,
        hasEnterpriseRiskManagementAccess,
    };
}
